export const formatAIConfigOverrides = (value) => {
    if (!value || typeof value !== "object" || Array.isArray(value)) {
        return "";
    }

    return JSON.stringify(value, null, 2);
};

export const parseAIConfigOverrides = (value) => {
    if (!value || value.trim() === "") {
        return {valid: true, value: null};
    }

    try {
        const parsed = JSON.parse(value);
        if (!parsed || typeof parsed !== "object" || Array.isArray(parsed)) {
            return {valid: false, value: null};
        }

        return {valid: true, value: parsed};
    } catch (e) {
        return {valid: false, value: null};
    }
};
